import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Tv } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(name, email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Account created. One step away from the wild side.");
      nav("/subscribe");
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg px-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-10">
          <Tv className="h-7 w-7 text-brand-primary" />
          <span className="font-display text-3xl"><span className="text-white">BALL0UT</span><span className="text-brand-primary neon-text">TV</span></span>
        </Link>
        <div className="border border-white/10 bg-brand-surface p-8 md:p-10">
          <h1 className="font-display text-3xl uppercase tracking-tight">Create account</h1>
          <p className="text-brand-muted text-sm mt-2">Join the network. Stream Boyz Gone Wild today.</p>

          <form onSubmit={submit} className="mt-8 space-y-5" data-testid="register-form">
            <div>
              <Label htmlFor="name" className="text-xs uppercase tracking-[0.2em] text-brand-muted">Name</Label>
              <Input id="name" required value={name} onChange={e=>setName(e.target.value)}
                data-testid="register-name-input"
                className="mt-2 bg-black border-white/10 text-white rounded-none h-12 focus-visible:ring-brand-primary focus-visible:ring-offset-0" />
            </div>
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-[0.2em] text-brand-muted">Email</Label>
              <Input id="email" type="email" required value={email} onChange={e=>setEmail(e.target.value)}
                data-testid="register-email-input"
                className="mt-2 bg-black border-white/10 text-white rounded-none h-12 focus-visible:ring-brand-primary focus-visible:ring-offset-0" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-[0.2em] text-brand-muted">Password</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={e=>setPassword(e.target.value)}
                data-testid="register-password-input"
                className="mt-2 bg-black border-white/10 text-white rounded-none h-12 focus-visible:ring-brand-primary focus-visible:ring-offset-0" />
              <div className="text-[11px] text-brand-muted mt-1.5">Min 6 characters.</div>
            </div>
            <Button type="submit" disabled={loading}
              data-testid="register-submit-btn"
              className="w-full bg-brand-primary hover:bg-brand-primaryHover text-white rounded-none h-12 uppercase tracking-[0.15em] font-semibold">
              {loading ? "Creating…" : "Create account"}
            </Button>
          </form>
          <div className="mt-6 text-sm text-brand-muted text-center">
            Already a member?{" "}
            <Link to="/login" className="text-brand-primary hover:underline" data-testid="register-login-link">Sign in</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
